import { Button } from '@fluentui/react-components';
import { Dismiss16Regular } from '@fluentui/react-icons';
import React from 'react';
import {
    container,
    nudgeBar,
    iconColumn,
    textColumn,
    textContent,
    contentContainer,
    dismissButtonContainer,
    bigText,
    smallText,
} from './MailListNudge.scss';
import { dismissNudgeTooltip } from './MailListNudge.locstring.json';
import loc from 'owa-localize';
import classnames from 'owa-classnames';
import { getDensityModeCssClass } from 'owa-fabric-theme';
import { isSingleLineListView } from 'owa-mail-layout';
import { observer } from 'owa-mobx-react';

const dismissIcon = <Dismiss16Regular />;

export interface MailListNudgeProps {
    icon: React.ReactNode;
    text: React.ReactNode;
    onClick: () => void;
    onDismiss: (evt: React.MouseEvent<unknown> | React.KeyboardEvent<unknown>) => void;
    onRendered?: () => void;
}

export default observer(function MailListNudge(props: MailListNudgeProps): JSX.Element | null {
    const { icon, text, onClick, onDismiss: onDismiss_0, onRendered } = props;

    const isMCL = isSingleLineListView();
    const densityClass = getDensityModeCssClass(bigText, isMCL ? smallText : bigText, smallText);

    const onKeyDown = React.useCallback(
        (event: React.KeyboardEvent<HTMLDivElement>) => {
            if (event.key === 'Enter' && event.target === event.currentTarget) {
                event.stopPropagation();
                onClick();
            }
        },
        [onClick]
    );

    const onDismiss = React.useCallback(
        (evt: React.MouseEvent<unknown>) => {
            evt.stopPropagation();
            onDismiss_0?.(evt);
        },
        [onDismiss_0]
    );

    React.useEffect(() => {
        onRendered?.();
    }, [onRendered]);

    return (
        <div className={container}>
            <div className={nudgeBar} onClick={onClick} onKeyDown={onKeyDown} tabIndex={0}>
                <div className={iconColumn}>{icon}</div>
                <div className={textColumn}>
                    <div className={contentContainer}>
                        <span className={classnames(textContent, densityClass)}>{text}</span>
                        <div className={dismissButtonContainer}>
                            <Button
                                size="small"
                                icon={dismissIcon}
                                appearance="transparent"
                                title={loc(dismissNudgeTooltip)}
                                onClick={onDismiss}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}, 'MailListNudge') as React.FunctionComponent<MailListNudgeProps>;
